import { removeDataMemoryService } from "@/business/shared/session/infrastructure/services/removeDataMemoryService";

export const closeSessionMemory = {
  async execute(): Promise<void> {
    await removeDataMemoryService.execute();
  },
};
